import { render } from "./Modal.vue?vue&type=template&id=74cb73ce&scoped=true"
const script = {}

import "./Modal.vue?vue&type=style&index=0&id=74cb73ce&scoped=true&lang=css"

import exportComponent from "/home/runner/work/prayerwall/prayerwall/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74cb73ce"]])

export default __exports__